/** @jsx jsx */

import { Border } from '@zapier/theme';
import { Icon } from '@zapier/design-system';
import { createKeyHandler } from '@zapier/common-utils';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    align-items: center;
    border-top: ${Border.size.default} solid ${Border.color.default};
    border-bottom: ${Border.size.default} solid ${Border.color.default};
    cursor: pointer;
    display: flex;
    font-size: 16px;
    height: 55px;
    justify-content: space-between;
    padding: 20px;
    @media screen and (min-width: 756px) {
      display: none;
    }
  `,
  sectionText: css`
    font-weight: 600;
  `,
  separator: css`
    margin: 0px 8px;
  `,
};

type Props = {
  menuToggled: boolean;
  onMenuToggle: () => void;
  section: string;
  step: string;
};

const defaultPropsValue = {
  menuToggled: false,
  onMenuToggle: () => {},
  section: '',
  step: '',
};

const GuideMenu = (props: Props) => {
  const { menuToggled, onMenuToggle, section, step } = props;

  return (
    <div
      css={Styles.root}
      onClick={onMenuToggle}
      onKeyDown={createKeyHandler(['enter'], onMenuToggle)}
      role="button"
      tabIndex={0}
    >
      <div>
        <span css={Styles.sectionText}>{section}</span>
        <span css={Styles.separator}>→</span>
        <span>{step}</span>
      </div>
      <div>
        <Icon name={menuToggled ? 'formX' : 'navMenu'} size={20} />
      </div>
    </div>
  );
};

GuideMenu.defaultProps = defaultPropsValue;

export default GuideMenu;
